import React from 'react'
import { getFormValue } from 'tyan/public/utility'

class ConfirmDataDiv extends React.Component {
	state = {
	}

	componentDidMount = () => {
	}

	handlerSave = () => {
		const { onClose, onSave } = this.props
		onSave && onSave(getFormValue(this, '基本信息', '退回原因'))
		onClose && onClose()
	}

	handlerClose = () => {
		const { onClose } = this.props
		onClose && onClose()
	}

	canSave = () => {
		return getFormValue(this, '基本信息', '退回原因')
	}

	fieldset基本信息 = () => {
		return [
			{ _text: '退回原因', labelAlign: 'top', required: true, maxRows: 3, },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		return <Body data={this} maxWidth={600}
			controls={
				[
					{ _button: '确认', handler: this.handlerSave, disabled: !this.canSave() },
					{ _button: '取消', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
				]}
		/>
	}
}

export default ConfirmDataDiv